import Quill from 'quill'
import 'quill/dist/quill.snow.css'

const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

export class QuillCustomClipboard extends Clipboard {
  onPaste(e: ClipboardEvent) {
    if (!e.clipboardData || !this.quill)
      return

    const range = this.quill.getSelection()

    const html = e.clipboardData.getData('text/html')
    const plainText = e.clipboardData.getData('text/plain')

    if (html && !!this.quill.options?.modules?.clipboard?.matchVisual) {
      const delta = this.convert(html)
      const index = (range?.index || 0) + delta.length()

      this.quill.updateContents(
        new Delta().retain(range?.index || 0).delete(range?.length || 0).concat(delta),
        'user',
      )
      this.quill.setSelection(index, 0)
    }
    else {
      const delta = new Delta().retain(range?.index || 0).delete(range?.length || 0).insert(plainText)
      const index = (range?.index || 0) + plainText.length

      this.quill.updateContents(delta, 'user')
      this.quill.setSelection(index, 0)
    }

    this.quill.scrollIntoView()
    e.preventDefault()
  }
}

export default defineNuxtPlugin(() => {
  if (process.client)
    Quill.register('modules/clipboard', QuillCustomClipboard, true)
})
